module.exports = __webpack_public_path__ + "static/media/LOGOMBTC1_Prancheta_1.03f938e8.png";